import Footer from '@osu/footer';
import { Mui, useFooterWithTOC, useScrollToHash, withDarkMode, withOSUTheming, withTableOfContents, } from '@osu/react-ui';
import { useRef } from 'react';
import Main from '../../Main/components';
import { MAIN_ID } from '../../util/constants';
import { AppProvider } from '../context';
// import OSUNavBar from "react-osu-navbar";
import { Navbar as OSUNavBar } from '@osu/navbar';
//import Navbar from "../../Navbar/containers";
import useCompleteAuthFlowHandler from '../../Authentication/hooks/useCompleteAuthFlowHandler';
import useAmplifyHub from '../../Common/hooks/useAmplifyHub';
import useCssVariableUpdater from '../hooks/useCssVariableUpdater';

function App(props = {}) {
  const { navHeight, darkMode } = props;
  const { ref } = useScrollToHash();
  const footerRef = useRef();
  const theme = Mui.useTheme();
  useFooterWithTOC({ ref: footerRef });
  const trigger = Mui.useScrollTrigger({
    disableHysteresis: true,
    threshold: navHeight,
  });

  return (
    <>
      <div className="App" ref={ref}>
        <OSUNavBar darkMode={darkMode} />
        {/* <Navbar /> */}
        <Main spacingTop={!trigger} className="anchor-link" id={MAIN_ID} />
        <Footer
          ref={footerRef}
          organization={'Office of Technology and Digital Innovation'}
          maintainedBy={{
            label: 'Student Web Team',
            href: 'mailto:student-web-support@lists.osu.edu',
          }}
        />
      </div>
    </>
  );
}

const TOCWrappedApp = withTableOfContents(App);

function Provider(props = {}) {
  const { darkMode } = props;
  const { navHeight } = useCssVariableUpdater();
  const { handleSignIn, handleSignOut } = useAmplifyHub();

  useCompleteAuthFlowHandler();

  const appContext = {
    handleSignIn,
    handleSignOut,
    navHeight,
    darkMode,
  };
  return (
    <AppProvider value={appContext}>
      <TOCWrappedApp darkMode={darkMode} navHeight={navHeight} />
    </AppProvider>
  );
}

export default withDarkMode(withOSUTheming(Provider));
